const GAME_KEYS = new Set([
  "KeyW", "KeyA", "KeyS", "KeyD", "KeyQ", "KeyE",
  "ArrowUp", "ArrowLeft", "ArrowDown", "ArrowRight",
  "Space", "ShiftLeft", "ShiftRight",
]);

export interface InputState {
  readonly keys: Set<string>;
  has: (code: string) => boolean;
  delete: (code: string) => void;
}

export class KeyboardInput implements InputState {
  readonly keys = new Set<string>();

  constructor() {
    const isInputElement = (el: EventTarget | null) =>
      el instanceof HTMLElement && /^(input|textarea|select)$/i.test(el.tagName);

    window.addEventListener("keydown", (e) => {
      if (isInputElement(e.target)) return;
      this.keys.add(e.code);
      if (GAME_KEYS.has(e.code)) e.preventDefault();
    });
    window.addEventListener("keyup", (e) => this.keys.delete(e.code));
  }

  has(code: string): boolean {
    return this.keys.has(code);
  }

  delete(code: string): void {
    this.keys.delete(code);
  }
}
